export interface PurchaseDespatchItemInvoiceReport {
  stockNo: string;
  supplierRef: string;
  productKey: string;
  productDescription: string;
  makeUp: string;
  grossQuantity: number;
  nettQuantity: number;
  price: number;
  value: number;
  unitOfMeasure: string;
  noOfItems: number;
  currencySymbol: string;
}
